import React from "react";

import CheckBoxIcon from "@mui/icons-material/CheckBox";
import { Checkbox, Stack, Typography } from "@mui/material";
import { WorkspaceSimpleFileIcon } from "assets/material-custom-icons";
import { MaterialTooltip } from "components/tooltips/MaterialTooltip";
import { DealFolderForm, IFile } from "store/types";
import { Document } from "store/types";

import { useFilesPickerContext } from "../hooks/files-picker-context";

interface Props {
  data: UnitedArray;
  subIndex: number;
}

export type UnitedArray = Array<DealFolderForm | IFile | Document>;

export const UnitedList: React.FC<Props> = ({ data, subIndex }) => {
  const { isItemSelected, selectItem, isSelectionDisabled } = useFilesPickerContext();
  return (
    <Stack direction="column">
      {data.map((item) => {
        return (
          <Stack direction="row" alignItems="center" key={item.id}>
            <Checkbox
              checkedIcon={<CheckBoxIcon sx={{ fill: "#0A3142" }} />}
              checked={isItemSelected(item.id, "files")}
              disabled={isSelectionDisabled(item.id)}
              onChange={() => selectItem({ id: item.id, kind: "files", parentId: item.section_id })}
            />
            <Stack
              direction="row"
              alignItems="center"
              sx={{
                paddingLeft: `${(subIndex - 1) * 40}px`,
                width: "90%",
                height: "100%",
                borderBottom: "1px solid  #DAE0E2"
              }}
              gap="10px"
            >
              <WorkspaceSimpleFileIcon />
              <MaterialTooltip
                variant="dark"
                title={(item as IFile).name}
                disableHoverListener={!(item as IFile).name || (item as IFile).name.length <= 30}
              >
                <Typography
                  sx={{
                    fontSize: "16px",
                    color: "#0a3142",
                    whiteSpace: "nowrap",
                    textOverflow: "ellipsis",
                    overflow: "hidden"
                  }}
                >
                  {(item as IFile).name}
                </Typography>
              </MaterialTooltip>
            </Stack>
          </Stack>
        );
      })}
    </Stack>
  );
};
